import React from 'react'
import { motion } from 'framer-motion'
import { Quote, Star } from 'lucide-react'
import { useT } from '@/context/TranslateCtx'

export default function Testimonials() {
  const { t } = useT()
  const testimonials = [
    { idx: 1 }, { idx: 2 }, { idx: 3 },
  ]
  const container = { hidden: {}, visible: { transition: { staggerChildren: 0.2 } } }
  const card = {
    hidden: { opacity: 0, y: 60, scale: 0.9 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 120, damping: 18 } }
  }

  return (
    <motion.section id="testimonials" className="py-32 bg-white" variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
      <motion.h2 className="text-4xl md:text-5xl font-extrabold text-center text-primary mb-20" variants={card}>
        {t('testimonials.heading')}
      </motion.h2>
      <div className="container grid gap-12 md:grid-cols-3">
        {testimonials.map((tst, i) => (
          <motion.div
            key={i}
            variants={card}
            whileHover={{ translateY: -6 }}
            className="relative bg-gray-50 rounded-3xl shadow-xl p-10 flex flex-col"
          >
            <div className="absolute -top-6 left-8 bg-primary text-white rounded-full p-3 shadow-lg">
              <Quote size={24} />
            </div>
            <div className="w-20 h-20 bg-gray-100 rounded-full mx-auto mb-6 flex items-center justify-center text-gray-400">
              Image
            </div>
            <div className="flex justify-center mb-4 text-warning">
              {[...Array(5)].map((_, idx) => (
                <Star key={idx} size={18} fill="currentColor" className="mr-1" />
              ))}
            </div>
            <p className="text-gray-700 text-base md:text-lg italic leading-relaxed mb-6">
              “{t(`testi.${tst.idx}.text`)}”
            </p>
            <div className="mt-auto text-center">
              <p className="text-lg md:text-xl font-semibold">{t(`testi.${tst.idx}.name`)}</p>
              <p className="text-sm md:text-base text-gray-500">{t(`testi.${tst.idx}.role`)}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  )
}
